import type { Dictionnaire } from '../type';

export const messages: Dictionnaire['messages'] = {
  amis: {
    croise: 'You met at an event',
    soiMeme: "You can't add yourself",
    compteOfficiel: "The app's account can't be added as a friend. You can write to it.",
    bloque: "You've blocked this member: unblock them before sending a friend request",
    refuse: "This member isn't accepting your request right now",
    plusDeDemande: 'This request no longer exists',
    nouveau: 'New to the spot',
  },
  erreurs: {
    plusDeConversation: 'This conversation no longer exists',
    pasMembre: "You're not part of this conversation",
    demandeEnAttente: 'Your message was sent. You can keep going once this person has replied.',
    plusAmis: "You're no longer friends: this conversation is closed",
    injoignable: "This member isn't receiving your messages right now",
    vide: 'Write a message before sending it',
    effacerLesSiens: 'You can only delete your own messages',
    modifierLesSiens: 'You can only edit your own messages',
    tropTardPourModifier: 'A message can only be edited within 15 minutes of sending it.',
    priveSansNom: "A private conversation doesn't have a name",
    renommerAdmin: 'Only the admin can rename the group',
    nomDuGroupe: 'Give the group a name',
    priveSansDescription: "A private conversation doesn't have a description",
    descriptionAdmin: 'Only the admin can change the description',
    priveSansAdmin: "A private conversation doesn't have an admin",
    passerAdmin: 'Only the group admin can hand over',
    plusDansLeGroupe: 'This member is no longer in the group',
    priveSansMembres: "A private conversation doesn't have members",
    retirerAdmin: 'Only the group admin can remove a member',
    utiliseQuitter: 'Use “Leave group”',
    priveSansPhoto: "A private conversation doesn't have a photo",
    photoAdmin: 'Only the group admin can change its photo',
    soiMeme: "You can't chat with yourself",
    bloque: "You've blocked this member. Unblock them from their profile to write to them.",
    priveFermee: "A private conversation can't take other members",
    groupeDeSortie: 'You join this group by joining the event, not by invitation',
    groupeDAsso: 'You join this group by joining the society, not by invitation',
    amisSeulement: 'You can only add your friends to a group',
    priveNeSeQuittePas: "A private conversation can't be left",
    successeur: 'Choose who takes over the group before leaving.',
  },
  apercu: {
    groupe: 'Group',
    photo: 'Photo',
    vocal: 'Voice message',
    video: 'Video',
    sortie: 'Shared event',
    post: 'Shared post',
    nouveau: 'New message',
  },
  commun: {
    photo: 'Photo',
    vocal: 'Voice message',
    video: 'Video',
    sortie: 'Shared event',
    post: 'Shared post',
    message: 'Message',
    supprime: 'Message deleted',
    ecrit: 'typing...',
    nouveauMessage: 'New message',
    quitterGroupe: 'Leave group',
    aucunMembre: 'No members found',
    verifie: 'Check the spelling of the username.',
    aucunAmi: 'No friends yet',
    chercheUnPseudo: "Search for a username to invite someone who isn't your friend yet.",
    rechercherPseudo: 'Search for a username...',
    infosGroupe: 'Group info',
    membres: 'Members',
    toi: 'You',
    moi: 'Me',
    retirerQuelquun: (nom: string) => `Remove ${nom}`,
    laisserEtPartirQ: (nom: string) => `Leave the group to ${nom} and go?`,
  },
  conversation: {
    pasParti: "This message couldn't be sent.",
    pasModifie: "This message couldn't be edited.",
    microIndisponible: 'Microphone unavailable',
    vocalImpossible: "Couldn't send the voice message",
    envoiImpossible: "Can't send right now.",
    copie: 'Message copied.',
    plusCharge: 'This message is no longer in the loaded part of the conversation.',
    reactionEchec: "The reaction didn't go through. Try again.",
    effacement: 'Messages are deleted one week after being read.',
    pasAmis: "You're not friends: you can only send one message. The conversation will open if this person replies.",
    dernierMessage: 'Go to the latest message',
    plusAmis: "You're no longer friends: this conversation is closed. Send them a friend request again from their profile to pick up the conversation.",
    voirCite: 'See the quoted message',
    annulerReponse: 'Stop replying to this message',
    annulerModif: 'Stop editing this message',
    modifierLeMessage: 'Edit message',
    ecrire: 'Write a message...',
    annulerEnregistrement: 'Cancel recording',
    reprendre: 'Resume recording',
    galerie: 'Choose from gallery',
    enregistrerVocal: 'Record a voice message',
    lacherAnnuler: 'Release to cancel',
    lacherEnvoyer: 'Release to send',
    envoyerVocal: 'Send voice message',
    envoyer: 'Send',
    actions: 'Message actions',
    autreEmoji: 'Choose another emoji',
    repondre: 'Reply',
    copier: 'Copy text',
    modifier: 'Edit',
    infos: 'Info',
    supprimerQ: 'Delete this message?',
    supprimer: 'Delete',
    chercherEmoji: 'Search emoji',
    reactions: 'Reactions',
    retraitEchec: "The removal didn't go through. Try again.",
    appuyerSupprimer: 'Tap to remove.',
    infosMessage: 'Message info',
    vu: 'Seen',
    pasEncore: 'not yet',
    distribue: 'Delivered',
    ceMembre: 'this member',
    photoEnvoyee: 'Photo sent in the conversation',
    voirReactions: 'See who reacted',
    postIndisponible: 'This post is no longer available.',
    voirProfil: (nom: string) => `View ${nom}'s profile`,
    plusieursEcrivent: (n: number) => `${n} people are typing...`,
    appelerVideo: (nom: string) => `Video call ${nom}`,
    appeler: (nom: string) => `Call ${nom}`,
    nouveaux: (n: number) => `${n} new message${n === 1 ? '' : 's'}`,
    retirerReaction: (emoji: string) => `Remove ${emoji}`,
    reagirAvec: (emoji: string) => `React with ${emoji}`,
    aucunEmoji: (quete: string) => `No emoji for “${quete}”.`,
    systeme: {
    retire: (nom: string) => `${nom} was removed from the group.`,
    rejoint: (nom: string) => `${nom} joined the group.`,
    quitte: (nom: string) => `${nom} left the group.`,
    tuAsQuitte: 'You left the group.',
    plusAmi: (nom: string) =>
      `You're no longer friends with ${nom}. The conversation will resume when you're friends again.`,
  },
    appel: {
    manque: (video: boolean) => `Missed ${video ? 'video ' : ''}call`,
    duree: (video: boolean, duree: string) => `${video ? 'Video call' : 'Call'} · ${duree}`,
  },
    lu: 'Read',
    modifie: 'Edited',
  },
  ajouterAmis: {
    titre: 'Add friends',
    boutons: {
      none: 'Add',
      requested: 'Requested',
      incoming: 'Accept',
      friends: 'Friends',
    },
    demandesRecues: (n: number) => `Requests received · ${n}`,
    suggestions: (lieu: string | null) => `Suggestions${lieu ? ` in ${lieu}` : ''}`,
    tousLesMembres: (n: number) => `All members · ${n}`,
    accepter: (nom: string) => `Accept ${nom}`,
    refuser: (nom: string) => `Decline ${nom}`,
  },
  ajouterMembres: {
    impossible: "Couldn't add right now.",
    titre: 'Add members',
    choisis: 'Choose who to add',
    resultats: 'Results',
    tesAmis: 'Your friends',
    dejaMembre: 'Already a member',
    ajouter: (n: number) => `Add ${n} member${n === 1 ? '' : 's'}`,
  },
  groupe: {
    descriptionImpossible: "Couldn't save the description",
    renommageImpossible: "Couldn't rename",
    passerImpossible: "Couldn't hand over",
    retirerImpossible: "Couldn't remove this member",
    photoImpossible: "Couldn't save the photo",
    quitterImpossible: "Couldn't leave the group",
    quitterQ: 'Leave the group?',
    nommerAdmin: 'Make admin',
    retirer: 'Remove from group',
    changerPhoto: 'Change group photo',
    voirPhoto: 'View group photo full screen',
    modifierNom: 'Edit group name',
    ajouterMembre: 'Add a member',
    modifierDescription: 'Edit group description',
    ajouterDescription: 'Add a description',
    deQuoi: 'What is this group about?',
    admin: 'Admin',
    retirerQ: (nom: string) => `Remove ${nom} from the group?`,
    meta: (n: number, date: string) => `${n} member${n === 1 ? '' : 's'} · created on ${date}`,
  },
  passation: {
    orphelin: 'Who are you entrusting the group to?',
    laisser: 'Who are you leaving the group to?',
  },
  demandes: {
    titre: 'Message requests',
    aucune: 'No requests',
    aucuneAide: "First messages from members you don't know yet will arrive here.",
  },
  liste: {
    supprimerQ: 'Delete this conversation?',
    nouveauGroupe: 'New group',
    demandesMessage: 'Message requests',
    ajouterAmis: 'Add friends',
    reactiverSon: 'Unmute',
    sourdine: 'Mute',
    signaler: 'Report conversation',
    supprimer: 'Delete conversation',
    vide: 'No messages yet',
    videAide: 'Write to someone from their profile, or join an outing to get to know people.',
    rechercher: 'Search conversations...',
    discussions: 'Conversations',
    messages: 'Messages',
    comptes: 'Accounts',
    envoyerUnMessage: 'Send a message',
    toiDeuxPoints: 'You: ',
    enSourdine: 'Muted',
    plusAmis: "You're no longer friends",
    appelManque: 'Missed call',
    appel: 'Call',
    premier: 'Send a first message!',
    quitterQ: (nom: string) => `Leave ${nom}?`,
    demandesMessageEnAttente: (n: number) => `Message requests · ${n} pending`,
    demandesAmiEnAttente: (n: number) => `Friend requests · ${n} pending`,
    laisserEtPartirQ: (groupe: string, nom: string) => `Leave ${groupe} to ${nom} and go?`,
    aucuneDiscussion: (recherche: string) => `No conversation matches “${recherche}”.`,
    auteur: (nom: string) => `${nom}: `,
    nonLus: 'New messages',
    systeme: {
    quitte: (nom: string) => `${nom} left the group`,
    retire: (nom: string) => `${nom} was removed from the group`,
    rejoint: (nom: string) => `${nom} joined the group`,
  },
  },
  nouveauGroupe: {
    impossible: "Couldn't create right now.",
    titre: 'New group',
    creer: 'Create the group',
    choisirPhoto: 'Choose a group photo',
    nom: 'Group name',
    nomExemple: 'Picnics',
    description: 'Description',
    descriptionExemple: 'We meet at the park when the weather is nice',
    chercher: 'Search any username...',
    selectionnes: (n: number) => `${n} selected`,
  },
  annuaire: {
    rechercher: 'Search members',
    vide: 'Nobody else yet',
    videAide: 'Members of this server will show up here as soon as they have access.',
    aucun: (recherche: string) => `No member matches “${recherche}”`,
    ecrireA: (nom: string) => `Message ${nom}`,
    formation: {
      aide: "You'll show up in its section of the directory.",
      actuelle: 'Your programme',
    },
    sansFormation: 'Programme not given',
    voir: (nom: string) => `See members: ${nom}`,
    videFormation: 'Nobody in this programme yet',
    accueil: {
      etudiants: 'Students',
      etudiantsAide: 'Everyone, sorted by programme',
      associations: 'Societies',
      associationsAide: 'Their feed, their events, and how to join',
    },
    maFormation: {
      bouton: 'My programme',
      choisir: 'Set my programme',
      aucune: "Don't say",
      enregistree: 'Programme saved',
      impossible: "Your programme couldn't be saved. Try again.",
    },
    associations: {
      titre: 'Societies',
      categories: { bde: 'Student unions', citoyennes: 'Civic', creatives: 'Creative', culturelles: 'Cultural', humanitaires: 'Humanitarian', conviviales: 'Social', internationales: 'International', professionnelles: 'Professional', sportives: 'Sports and clubs' },
      vide: 'No societies yet',
      rechercher: 'Search for a society',
      aucune: (recherche: string) => `No society matches "${recherche}"`,
      membres: (n: number) => `${n} member${n > 1 ? 's' : ''}`,
      chef: 'Head',
      membre: 'Member',
      enAttente: 'Request sent',
      rejoindre: 'Ask to join',
      annulerDemande: 'Cancel my request',
      quitter: 'Leave the society',
      quitterQ: (nom: string) => `Leave ${nom}?`,
      demandeEnvoyee: 'Request sent to the head',
      fil: 'Feed',
      evenements: 'Events',
      lesMembres: 'Members',
      ecrire: 'Post in the feed',
      creerEvenement: 'Create an event',
      filVide: 'Nothing in the feed yet',
      evenementsVide: 'No upcoming events',
      demandes: (n: number) => `Requests to join (${n})`,
      accepter: (nom: string) => `Accept ${nom}`,
      refuser: (nom: string) => `Decline ${nom}`,
      retirer: (nom: string) => `Remove ${nom} from the society`,
      retirerQ: (nom: string) => `Remove ${nom} from the society?`,
      sansChef: "This society doesn't have a head to accept requests yet.",
      reserveMembres: 'Everyone can read its feed and events; only its members can post.',
      groupe: 'Society group',
      groupePasPret: 'The group is being set up, try again in a moment.',
      introuvable: 'Society not found',
      impossible: "That didn't work. Try again.",
      dansLeFil: (nom: string) => `In the ${nom} feed`,
      pourLAsso: (nom: string) => `${nom} event`,
      voir: (nom: string) => `See the society ${nom}`,
    },
    filtres: {
      titre: 'Filters',
      filtrer: 'Filter members',
      actifs: 'Filters on',
      formation: 'Programme',
      langues: 'Languages',
      effacer: 'Clear all',
      fermer: 'See members',
      aucun: 'No member matches these filters',
    },
  },
};
